import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import {
  mdiEye,
  mdiEyeOff,
  mdiStar,
  mdiStarOutline,
  mdiCheckCircle,
  mdiEmailCheckOutline,
  mdiDelete,
  mdiCloseCircleOutline,
  mdiAlertCircle,
} from '@mdi/js'

import execute from './helpers/httpInterceptor'
document.documentElement.setAttribute('lang', 'fr')

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      // Les 8 icônes utilisées dans le projet
      'mdi-eye': mdiEye,
      'mdi-eye-off': mdiEyeOff,
      'mdi-star': mdiStar,
      'mdi-star-outline': mdiStarOutline,
      'mdi-check-circle': mdiCheckCircle,
      'mdi-email-check-outline': mdiEmailCheckOutline,
      'mdi-delete': mdiDelete,
      'mdi-close-circle-outline': mdiCloseCircleOutline,
      'mdi-alert-circle': mdiAlertCircle,
    },
    sets: { mdi },
  },
})

const app = createApp(App)
app.use(store)
app.use(router)
app.use(vuetify)
execute()
app.mount('#app')
